let angular = require('angular');
import './style.scss';

renderLeftPanel.$inject = ['mediaContentUtils', '$rootScope'];

function renderLeftPanel(mediaContentUtils, $rootScope) {
    return {
        restrict: 'E',
        replace: true,
        transclude: {
            // item: '?friendRequest',
            shared: '?sharedPanel',
            // link: '?leftPanelLink',
            users: '?usersListPanel',
            firstLinksGroup: '?firstLinksGroup',
            secondLinksGroup: '?secondLinksGroup'
        },
        scope: {
            name: '=',
            avatar: '=',
            onlineMark: '=',
            avatarLink: '=?',
            sharedListTitle: '=',
            mediaContentSamples: '=?',
            allowShowMore: '=?',
            allowShowMoreShare: '=?',
            showAdditioanalMark: '=?',
            additionalMarkCustomIcon: '@?'
        },
        template: require('./template.html')
        ,
        link: function ($scope, element, attrs, controller) {
            $rootScope.$on('pageSwithed', () => {
                $scope.isCollapsed = true;
            });

            $scope.avatarStyle = {'background-image': `url('${$scope.avatar}')`}

            $scope.mobileHeader = undefined;

            $scope.$on('setMobileHeader', (e, val) => {
                $scope.mobileHeader = val;
            });

            $scope.$on('resetMobileHeader', (e, val) => {
                $scope.mobileHeader = undefined;
            });

            $scope.avatarClick = function () {
                if ($scope.avatarLink) {
                    document.location.href = $scope.avatarLink;
                }
            };

            $scope.isCollapsed = true;
            $scope.get_avatar_style = function () {
                return mediaContentUtils.generate_group_background($scope.avatar, $scope.mediaContentSamples);
            };
            $scope.showMoreClicked = false;
            $scope.showMore = function () {
                $scope.showMoreClicked = true;
                $scope.showMoreSharedClicked = true;
            };
            $scope.showMoreSharedClicked = false;
            $scope.showMoreShared = function () {
                $scope.showMoreSharedClicked = true;
                $scope.showMoreClicked = true;

            };
        }
    };
}

angular.module('mmApp.shared.leftPanel.renderLeftPanel', [])
    .directive('renderLeftPanel', renderLeftPanel);

export default 'mmApp.shared.leftPanel.renderLeftPanel';